module.exports = __webpack_public_path__ + "media/src/ui/icons/jpg_new-d353018f6c6c5acd99ed48ac9cc09e26.svg";